import React from 'react'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';

import Chart from './components/chart';
import useStyles from './styles'

export default function StandardsChart({context, standard, standardIndex}) {

  const classes = useStyles()

  const {standardsContext, quizAssessmentToReview: standards, translate, quizStandardScale = {}} = context
  
  const {assessmentIndicators, assessmentStandards} = standardsContext

  const {proficient, parcial, noProficient} = quizStandardScale[0] || {};

  const proScoreMaxLimit = proficient?.maxValue || 100;
  const proScoreMinLimit = proficient?.minValue || 75;
  const parcialScoreMaxLimit = parcial?.maxValue || 74;
  const parcialScoreMinLimit = parcial?.minValue || 60;
  const noProScoreMaxLimit = noProficient?.maxValue || 59;
  const noProScoreMinLimit = noProficient?.minValue || 0;

  const scaleLabels = (value = 0) => {
   return( 
        value <= proScoreMaxLimit && value >= proScoreMinLimit 
        ?  proficient 
        : value <= parcialScoreMaxLimit && value >= parcialScoreMinLimit 
            ? parcial 
            : value <= noProScoreMaxLimit && value >= noProScoreMinLimit
                ?  noProficient 
                : ''
        )
  }

  let countAnswered = 0;
  let countTotal = 0;
  let percent = 0;
  let chartValues = [];

  assessmentStandards.items.map((stds, index) => {
	var pending = false;
	var codes = [];

    const hasReferences = stds.references.length > 0;
    const hasIndicators = Object.keys(assessmentIndicators).length > 0;

	chartValues.push({sectionId: stds.id, value: 0});

    if(hasReferences && hasIndicators){
        countAnswered = 0;
        countTotal = 0;
        stds.references.map((row) => {
            if(codes.indexOf(assessmentIndicators[row.id][0].code) === -1){
                codes.push(assessmentIndicators[row.id][0].code);
                assessmentIndicators[row.id][0]?.references.forEach(question => {
                    if (standards.results[question.id].pending) {
                        pending = true;
                    } else{
                        if (standards.results[question.id].points > 0 ) countAnswered++;
                        countTotal++;
                    }
                })
   
                percent = (countAnswered/countTotal)*100;  
                chartValues[index].value = Math.round(percent);
   
                } else{
                    return
                }
       });
    }else{
        countAnswered = 0;
        countTotal = 0;
        stds.expectations.map((expectation) => {
            if(codes.indexOf(expectation.description) === -1){
                codes.push(expectation.description);
                expectation.references.forEach(question => {
                    if (standards.results[question.id].pending) {
                        pending = true
                    }else{
                        if (standards.results[question.id].points > 0 ) countAnswered++;
                        countTotal++;
                    }
                })
   
                percent = (countAnswered/countTotal)*100;  
                chartValues[index].value = Math.round(percent);
   
                } else{
                    return
                }
       });
    }
  })

  return ( 
        <Grid 
            container 
            direction="row"
            justifyContent="space-between"
        >
            <Grid item xs={5} md={5} className={classes.grid} justifyContent="flex-start">
                <Box className={classes.tableTitle}>
                    {standard.name}
                </Box>
            </Grid>
            <Grid item xs={5} md={5} className={classes.grid} justifyContent="flex-end">
                    <Box className={classes.chart}>	
                        <Chart 
                            series={[chartValues[standardIndex]?.value] || [0]} 
                            barColor={scaleLabels(chartValues[standardIndex]?.value)?.color}
                            color="#66deba"
                            /> 		
                    </Box>
                    <Box className={classes.chartTitle}>
                            {translate(`standards-${scaleLabels(chartValues[standardIndex]?.value)?.label}`)}
                        <Box className={classes.chartSubTitle}>
                            {`${scaleLabels(chartValues[standardIndex]?.value)?.maxValue}% - ${scaleLabels(chartValues[standardIndex]?.value)?.minValue}%`}
                        </Box>
                    </Box>
            </Grid>
        </Grid>	
    )
}
